import { render, staticRenderFns } from "./PH2VC2.vue?vue&type=template&id=0830b88a&scoped=true"
import script from "./PH2VC2.vue?vue&type=script&lang=js"
export * from "./PH2VC2.vue?vue&type=script&lang=js"
import style0 from "./PH2VC2.vue?vue&type=style&index=0&id=0830b88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0830b88a",
  null
  
)

export default component.exports